export const hasAtMostOneAgent = agents => (agents || []).length <= 1
